export type SelectKeys<T, K> = K extends keyof T ? K : never;

export type NonUndefined<T> = T extends undefined ? never : T;

export type Extends<T, U extends T> = U;

export function never(message: string): never {
    throw new Error(message);
}
